var render = function render(){var _vm=this,_c=_vm._self._c;return _c('reclamos-lista-pedidos',{attrs:{"vista":_vm.modulo}})
}
var staticRenderFns = []

export { render, staticRenderFns }